import { Entry } from '../Entry'

export function Entry20240131() {
  return (
    <Entry title="Jan 31 2024 - v3.5.12">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/15589/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
